import { Fun } from 'widgets-for-react'
import {
  ComponentSaverState,
  componentSaverStateUpdaters,
  initialComponentSaverState,
} from '../../../../components/componentSaver/componentSaverState'
import { getComponentTeasers } from '../../../../components/componentTeasers/componentTeasersApi'
import {
  ComponentTeasersState,
  initialComponentTeasersState,
} from '../../../../components/componentTeasers/componentTeasersState'

export type ComponentsBlockState = {
  componentTeasersState: ComponentTeasersState
  componentSaverState: ComponentSaverState
}

export const initialComponentsBlockState = (
  componentIds: number[]
): ComponentsBlockState => ({
  componentTeasersState: initialComponentTeasersState(() =>
    getComponentTeasers(componentIds)
  ),
  componentSaverState: initialComponentSaverState,
})

export const componentsBlockStateUpdaters = {
  componentSaverStateUpdater:
    (
      update: Fun<
        ComponentSaverState,
        ComponentSaverState & { reloadCollections?: boolean }
      >
    ) =>
    (
      state: ComponentsBlockState
    ): ComponentsBlockState & { reloadCollections?: boolean } => {
      const { reloadCollections, ...newComponentSaverState } = update(
        state.componentSaverState
      )
      return {
        ...state,
        componentSaverState: newComponentSaverState,
        reloadCollections: reloadCollections,
      }
    },
  componentTeasersStateUpdater:
    (
      update: Fun<
        ComponentTeasersState,
        ComponentTeasersState & { saveComponentId: number | 'none' }
      >
    ) =>
    (state: ComponentsBlockState): ComponentsBlockState => {
      const newComponentTeasersState = update(state.componentTeasersState)
      return {
        ...state,
        componentTeasersState: newComponentTeasersState,
        componentSaverState:
          newComponentTeasersState.saveComponentId === 'none'
            ? state.componentSaverState
            : componentSaverStateUpdaters.startSavingUpdater(
                newComponentTeasersState.saveComponentId
              )(state.componentSaverState),
      }
    },
}
